import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ServicePro = createSvgIcon(
  <path d="M13.125 1.57V0h-2.25v1.57A9.002 9.002 0 0 0 3 10.5H1.5v2.25h2.25v3a8.25 8.25 0 1 0 16.5 0v-3h2.25V10.5H21a9.002 9.002 0 0 0-7.875-8.93Zm-2.25 2.273V7.5h2.25V3.843A6.752 6.752 0 0 1 18.75 10.5H5.25a6.752 6.752 0 0 1 5.625-6.657ZM6 15.75v-3h12v3a6 6 0 1 1-12 0Z" />,
  'ServicePro'
);

export { ServicePro };